import { render, staticRenderFns } from "./NgsIconGroup.vue?vue&type=template&id=cf3ba8a6&scoped=true&"
import script from "./NgsIconGroup.vue?vue&type=script&lang=js&"
export * from "./NgsIconGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3ba8a6",
  null
  
)

export default component.exports